import { Component, Input, OnInit } from '@angular/core';
import { RentalsUnitedService } from '../..';
import { first } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiResponse } from '@app/_models';

@Component({
    selector: 'app-ru-prices',
    templateUrl: './ru-prices.component.html',
    styleUrls: ['./ru-prices.component.css'],
    standalone: false
})
export class RuPricesComponent implements OnInit {

	selectedShortTermRental: any;
	ruPrices: any = [];
	shortTermRentals: any = [];

	// data
	apiResponse: ApiResponse;

	@Input() ruAccount: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;
	formErrorMessage: String;
	ruResponse:any;

	validationMessages = {
		shortTermRentalId: [{ type: 'required', message: 'Property is required' }],
		startDate: [],
		endDate: []
	};

	constructor(
		private rentalsUnitedService: RentalsUnitedService,
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private propertyService: PropertyService,
		private router: Router,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private reportService: ReportService,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder) { }



	ngOnInit(): void {
		this.buildForm();
		this.loadShortTermRentals();
	}

	onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		this.pushRuPrices(this.form1.value);
	}

	onShowPrices() {
		if (this.form1.invalid) {
			return;
		}
		this.loadRuPrices(this.form1.value);
	}

	onSyncAllPricesClick() {
		let ruRequest = { startDate: '', endDate: '' };
		this.pushAllPrices(ruRequest);
	}

	pushRuPrices(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.pushPrices(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushRuPrices: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success: Push Price', detail: res.message, life: 3000 });
					this.ruResponse = JSON.stringify(res.data);
					this.loadRuPrices(this.form1.value);
				},
				err => {
					console.log('Failed: pushRuPrices: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Failed: Push Price', detail: err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	pushAllPrices(ruRequest) {
		this.formLoading = true;
		this.rentalsUnitedService.pushAllPrices(ruRequest)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushAllPrices: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Push All Prices', detail: res.message, life: 3000 });
					this.ruResponse = JSON.stringify(res.data);
				},
				err => {
					console.log('Failed: pushAllPrices: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Failed: pushAllPrices', detail: err.message, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	loadRuPrices(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.listPrices(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('loadRuPrices: ' + JSON.stringify(res));
					this.ruPrices = res.data.prices.Prices.FSPSeasons;
				},
				err => {
					console.log('Failed: loadRuPrices: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Failed: loadRuPrices', detail: err.message, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList()
			.subscribe(
				res => {
					this.shortTermRentals = res.data.propertySummaryList;
					this.shortTermRentals.unshift({});
				},
				err => {
					console.log('Failed: loadShortTermRentals: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Failed: loadShortTermRentals', detail: err.message, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			shortTermRentalId: ['', Validators.required],
			startDate: [''],
			endDate: [''],
			ruAccount: [this.ruAccount],
		});
	}
}
